import { Pipe, PipeTransform } from "@angular/core";
import { IObservation, IObservationDefinition } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "filterObsDefinitions" })
export class FilterObsDefinitionsPipe implements PipeTransform {
  transform(obsDefinitions: IObservationDefinition[], observations: IObservation[]): IObservationDefinition[] {
    const filteredDefinitions: IObservationDefinition[] = [];
    const defLoincs = new Set(obsDefinitions.map((def) => def.loinc));

    for (const definition of obsDefinitions) {
      // Check if a corresponding observation exists for this definition
      const matchingObservation = observations.find((observation) => observation.code.coding[0].code === definition.loinc);

      if (matchingObservation) {
        filteredDefinitions.push({
          ...definition,
          components: definition.components?.filter((c) => !defLoincs.has(c.loinc) || c.loinc === definition.loinc),
        });
      }
    }

    return filteredDefinitions;
  }
}
